/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Payments_RefundInputs */

const cs_deal_payments_refund = /** @type {(inputs: Deal_Payments_RefundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Označit vráceno`)
};

const en_deal_payments_refund = /** @type {(inputs: Deal_Payments_RefundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark refunded`)
};

/**
* | output |
* | --- |
* | "Mark refunded" |
*
* @param {Deal_Payments_RefundInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_payments_refund = /** @type {((inputs?: Deal_Payments_RefundInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Payments_RefundInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_payments_refund(inputs)
	return cs_deal_payments_refund(inputs)
});